import { Injectable } from '@angular/core';
import { Http, Response, RequestOptions, Request, Headers, ResponseContentType, ResponseOptions } from '@angular/http';
import { Observable } from 'rxjs';
import 'rxjs/Rx';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/toPromise';
import 'rxjs/add/operator/catch';
import 'rxjs/add/Observable/throw';
import 'rxjs/add/operator/toPromise';
import { global } from '../../models/global';
import { UpdateNotification } from 'src/app/Models/login/profile';
import { DropDownResponse } from 'src/app/Models/Dashboard/DashboardFilters';

@Injectable({
    providedIn : 'root'
})
export class DashboardService {

    ROOT_URL : string = "";
    constructor(private http : Http) {
        let g : global = new global();
        this.ROOT_URL = g.getApiUrl();
    }

    dashboardFilters() : Observable<any> {
        let userID = localStorage.getItem('mcmt_userId');
        let headers = new Headers({ 'Content-Type': 'application/json;charset=utf-8', 'Authorization':'Bearer '+ localStorage.getItem('mcmt_token'), 'UserID': localStorage.getItem('mcmt_userId') });
        let requestoptions : RequestOptions = new RequestOptions({
            method : 'GET',
            url : this.ROOT_URL + "/api/Dashboard/DashboardFilter?userID="+userID,
            headers : headers
        })
        
        return this.http.request(new Request(requestoptions))
            .map((res : Response) => {
                return res.json();
            });

    }

    getMenuList() : Observable<any> {
        let userID = localStorage.getItem('mcmt_userId');
        let headers = new Headers({ 'Content-Type': 'application/json;charset=utf-8', 'Authorization':'Bearer '+ localStorage.getItem('mcmt_token'), 'UserID': localStorage.getItem('mcmt_userId') });
        let requestoptions : RequestOptions = new RequestOptions({
            method : 'GET',
            url : this.ROOT_URL + "/api/Dashboard/GetMenuList?UserID="+userID,
            headers : headers
        })
        
        return this.http.request(new Request(requestoptions))
            .map((res : Response) => {
                return res.json();
            });

    }
    
    dashboardDetails(jobNumber : any, name : any, type : any, brand : any, crop : any, requirementType : any,requirementYear : any,
        language : any, status : any, ma:any,month:any) : Observable<any> {
        let _body = {
            "UserID" : localStorage.getItem('mcmt_userId'),
            "JobNumber" : jobNumber,
            "RMHName" : name,
            "JobType" : type,
            "Brand" : brand,
            "Crop" : crop,
            "RequirementType" : requirementType,
            "RequirementYear" : requirementYear,
            "Language" : language,
            "OrderStatus" : status,
            "MA":ma,
            "Month":month
            }
            
        let headers = new Headers({ 'Content-Type': 'application/json;charset=utf-8', 'Authorization':'Bearer '+ localStorage.getItem('mcmt_token'), 'UserID': localStorage.getItem('mcmt_userId')  });
        let requestoptions : RequestOptions = new RequestOptions({
            method : 'POST',
            url : this.ROOT_URL + "/api/Dashboard/DashboardDetails",
            headers : headers,
            body : _body
        })
        
        return this.http.request(new Request(requestoptions))
            .map((res : Response) => {
                return res.json();
            });

    }
    getrmhonjobnumberselection(jobNumber : any,rmh:any,brand:any,ma:any) : Observable<any> {
        let _body = {
            "UserID" : localStorage.getItem('mcmt_userId'),
            "JobNumber" : jobNumber,
            "RMHName":rmh,
            "Brand":brand,
            "MA":ma
            }
            
        let headers = new Headers({ 'Content-Type': 'application/json;charset=utf-8', 'Authorization':'Bearer '+ localStorage.getItem('mcmt_token'), 'UserID': localStorage.getItem('mcmt_userId')  });
        let requestoptions : RequestOptions = new RequestOptions({
            method : 'POST',
            url : this.ROOT_URL + "/api/Dashboard/GetRMHJobnumber",
            headers : headers,
            body : _body
        })
        
        return this.http.request(new Request(requestoptions))
            .map((res : Response) => {
                return res.json();
            });

    }

    downloadExcel(jobNumber : any, name : any, type : any, brand : any, crop : any, requirementType : any,requirementYear : any,
        language : any, status : any,ma:any,month:any) : Observable<any> {
        let _body = {
            "UserID" : localStorage.getItem('mcmt_userId'),
            "JobNumber" : jobNumber,
            "RMHName" : name,
            "JobType" : type,
            "Brand" : brand,
            "Crop" : crop,
            "RequirementType" : requirementType,
            "RequirementYear" : requirementYear,
            "Language" : language,
            "OrderStatus" : status,
            "MA":ma,
            "Month":month
            }
            let headers = new Headers({ 'Content-Type': 'application/json;charset=utf-8', 'Authorization':'Bearer '+ localStorage.getItem('mcmt_token'), 'UserID': localStorage.getItem('mcmt_userId')  });
        let requestoptions : RequestOptions = new RequestOptions({
            method : 'POST',
            url : this.ROOT_URL + "/api/Dashboard/DownloadExcel",
            headers : headers,
            body : _body,
            responseType : ResponseContentType.Blob
        })
        
        return this.http.request(new Request(requestoptions))
            .map((res : Response) => {
                var blob = new Blob([res.blob()], { type: 'xlsx' })
                return blob;
            });

    }

    getPODetails(jobNumber : string) : Observable<any> {
        let headers = new Headers({ 'Content-Type': 'application/json;charset=utf-8', 'Authorization':'Bearer '+ localStorage.getItem('mcmt_token'), 'UserID': localStorage.getItem('mcmt_userId') });
        let requestoptions : RequestOptions = new RequestOptions({
            method : 'GET',
            url : this.ROOT_URL + "/api/Dashboard/GetPODetails?jobNumber="+jobNumber,
            headers : headers
        })
        
        return this.http.request(new Request(requestoptions))
            .map((res : Response) => {
                return res.json();
            });

    }
    downloadFile(fileName : string, url : string) {
        url = this.ROOT_URL + url;
        window.open(this.ROOT_URL + 'MC_MaterialTrackingAPI/FMC.MCMaterial.API/Templates/' + fileName, '_blank');
        return this.http.get(url, {
        responseType : ResponseContentType.Blob//, search: // query string if have
        }).map(res => {
            return {
                
                filename : fileName,
                data : res.blob()
                
            };
        }).subscribe(res => {
            window.location.href = this.ROOT_URL + '/api/Templates/' + res.filename;
        }, error => {
            console.log('download error:', JSON.stringify(error));
        }, () => {
             console.log('Completed file download.')
        });
    }

    getProcessTimeline() : Observable<any> {
        let userID = localStorage.getItem('mcmt_userId');
        let headers = new Headers({ 'Content-Type': 'application/json;charset=utf-8', 'Authorization':'Bearer '+ localStorage.getItem('mcmt_token'), 'UserID': localStorage.getItem('mcmt_userId') });
        let requestoptions : RequestOptions = new RequestOptions({
            method : 'GET',
            url : this.ROOT_URL + "/api/Dashboard/GetProcessTimeline?userID="+userID,
            headers : headers
        })
        
        return this.http.request(new Request(requestoptions))
            .map((res : Response) => {
                return res.json();
            });

    }


    updateNotification(detail : UpdateNotification[]) : Observable<any> {
        let _body = {
            "UserID" : localStorage.getItem('mcmt_userId'),
            "Data" : detail
          }
          let headers = new Headers({ 'Content-Type': 'application/json;charset=utf-8', 'Authorization':'Bearer '+ localStorage.getItem('mcmt_token'), 'UserID': localStorage.getItem('mcmt_userId') });
        let requestoptions : RequestOptions = new RequestOptions({
            method : 'POST',
            url : this.ROOT_URL + "/api/Account/UpdateNotification",
            headers : headers,
            body : _body
        })
        
        return this.http.request(new Request(requestoptions))
            .map((res : Response) => {
                return res.json();
            });

    }
    getJobnumberDropdowns(ddlResponse : DropDownResponse) : Observable<any> {
        let _body = {
            "UserID" : localStorage.getItem('mcmt_userId'),
            "Data" : ddlResponse
          }
          let headers = new Headers({ 'Content-Type': 'application/json;charset=utf-8', 'Authorization':'Bearer '+ localStorage.getItem('mcmt_token'), 'UserID': localStorage.getItem('mcmt_userId') });
        let requestoptions : RequestOptions = new RequestOptions({
            method : 'POST',
            url : this.ROOT_URL + "/api/Account/GetJobnumberDropdowns",
            headers : headers,
            body : _body
        })
        
        return this.http.request(new Request(requestoptions))
            .map((res : Response) => {
                return res.json();
            });

    }
}
